import { ReactNode } from 'react';

import { styled } from '@mui/material';

import {
  ErrorCircleIcon,
  WarningCircleIcon,
  InfoCircleIcon,
} from '@app-velocity/icons';

import { TAppraisalDto } from '@app-velocity/av-api-v2';

const getIconColorByLevel = (level: TAppraisalDto['level']) => {
  switch (level) {
    case 'ERROR':
      return 'var(--error-error-icon-primary-color)';
    case 'WARNING':
      return 'var(--warning-warning-icon-primary-color)';
    case 'INFO':
      return 'var(--info-info-icon-primary-color)';
  }
};

const getTextColorByLevel = (level: TAppraisalDto['level']) => {
  switch (level) {
    case 'ERROR':
      return 'var(--error-error-text-primary-color)';
    case 'WARNING':
      return 'var(--warning-warning-text-primary-color)';
    case 'INFO':
      return 'var(--info-info-text-primary-color)';
  }
};

const getIcon = (level: TAppraisalDto['level']): ReactNode => {
  switch (level) {
    case 'ERROR':
      return <ErrorCircleIcon />;
    case 'WARNING':
      return <WarningCircleIcon />;
    case 'INFO':
      return <InfoCircleIcon />;
  }
};

const StyledAppraisalCount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const SingleCount = styled('div')<{ level: TAppraisalDto['level'] }>(
  ({ theme, level }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontWeight: 600,
    fontSize: 12,
    color: getTextColorByLevel(level),
    svg: {
      fill: getIconColorByLevel(level),
    },
  })
);

export type AppraisalsCountProps = {
  errors: number;
  warnings: number;
  info: number;
};

export const AppraisalsCount = ({
  errors,
  warnings,
  info,
}: AppraisalsCountProps) => {
  return (
    <StyledAppraisalCount>
      {errors ? (
        <SingleCount level="ERROR">
          {getIcon('ERROR')}
          {errors}
        </SingleCount>
      ) : null}
      {warnings ? (
        <SingleCount level="WARNING">
          {getIcon('WARNING')}
          {warnings}
        </SingleCount>
      ) : null}
      {info ? (
        <SingleCount level="INFO">
          {getIcon('INFO')}
          {info}
        </SingleCount>
      ) : null}
    </StyledAppraisalCount>
  );
};
